module.exports = __webpack_public_path__ + "img/computer_3.d109de10.png";